import React from 'react'
import * as UIcons from '@iconscout/react-unicons'

const TONE_BG = {
  purple: 'bg-purple',
  primary: 'bg-primary',
  success: 'bg-success',
  gold: 'bg-gold',
  blue: 'bg-[#60A5FA]',
  danger: 'bg-danger'
}

const ICONS = {
  impressions: UIcons.UilEye,
  video_starts: UIcons.UilPlayCircle,
  completed_views: UIcons.UilCheckCircle,
  cta_clicks: UIcons.UilMouse,
  reward_claims: UIcons.UilGift
}

// Each band tapers from the previous step's width down to the next step's width,
// so the stack reads as one continuous funnel rather than stepped bars.
function bandClipPath(topWidth, bottomWidth) {
  const topInset = (100 - topWidth) / 2
  const bottomInset = (100 - bottomWidth) / 2
  return `polygon(${topInset}% 0%, ${100 - topInset}% 0%, ${100 - bottomInset}% 100%, ${bottomInset}% 100%)`
}

export default function ConversionFunnel({ title, steps }) {
  const widths = steps.map((step) => Math.max(18, step.percent))

  return (
    <div className="w-full rounded-2xl border border-border-lines p-4">
      <p className="text-base font-semibold text-dark-blue mb-4">{title}</p>

      <div className="flex flex-col sm:flex-row gap-6">
        <div className="flex-1 flex flex-col items-center">
          {
            steps.map((step, index) => {
              const Icon = ICONS[step.key] || UIcons.UilChartLine
              const topWidth = index === 0 ? 100 : widths[index]
              const bottomWidth = index < steps.length - 1 ? widths[index + 1] : Math.max(12, widths[index] - 12)

              return (
                <div
                  key={step.key}
                  className={`w-full h-11 flex items-center justify-center text-white ${TONE_BG[step.tone] || 'bg-primary'}`}
                  style={{ clipPath: bandClipPath(topWidth, bottomWidth) }}
                >
                  <Icon size={16} />
                </div>
              )
            })
          }
        </div>

        <div className="flex-1 flex flex-col gap-3 justify-center">
          {
            steps.map((step) => (
              <div key={step.key} className="flex items-center justify-between gap-3 border-b border-border-lines last:border-0 pb-3 last:pb-0">
                <p className="text-xs font-medium text-secondary uppercase tracking-wide">{step.label}</p>
                <div className="flex items-center gap-3">
                  <p className="text-sm font-semibold text-dark-blue whitespace-nowrap">{step.value.toLocaleString()}</p>
                  <p className="text-xs text-secondary whitespace-nowrap">{step.percent}%</p>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
}
